
export default {
  data: () => ({
    
    selectedItems:    null,
    getItems:         null,

    // Selection
    canvasChart:      null,
    canvasForm:       null,

    rawData:          null,

    config:           null,
    menus:            null,
    chart:            null,
    primary:          null,
    secondary:        null,
    timeline:         null,
    grid:             null,
    legends:          null,
    summary:          null,
    milestone:        null,
  
    sundries:         null,
    current:          null,
    
    // PDF
    selectedItems:    null,
    getItems:         null,

  }),


  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },

  methods: {
    set_Gradients() {

    },

    set_selectedItems() {
      this.selectedItems = { 
        ...this.selectedItems,
        current: JSON.parse(JSON.stringify(this.current))
      }
    },
  },

}